import localStorageService from "app/services/localStorageService";
import { addMinutes } from "app/_helpers/helper";
import moment from "moment";
import {
  getContractor,
  getContractorForOtherModuel,
} from "../Contractor/ContractorService";
import { getAllSites, getAllSitesData } from "../ehs/ehsSiteServices";
import configureStore from "../../redux/Store";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import { clearContractorPersonStore } from "app/_pages/UserManagement/UserRegistration/helper";
import { fliterBtnType } from "app/_pages/UserManagement/Employee/Constant";
let { Store } = configureStore();
const { CallApi } = require("app/_helpers/CallApi/CallApi");

export const getAllContractorPerson = async (data, filterType = false) => {
  let storeKey;
  let storeType;

  switch (filterType) {
    case fliterBtnType.inActiveUnAssigned.type:
      storeKey = "conPersonInActiveUnassigned";
      storeType = USER_DATA_CONSTANT.CONTRACTOR_PERSON_IN_ACTIVE_UNASSIGNED;
      break;
    case fliterBtnType.inActiveAssigned.type:
      storeKey = "conPersonInActiveAssigned";
      storeType = USER_DATA_CONSTANT.CONTRACTOR_PERSON_IN_ACTIVE_ASSIGNED;
      break;
    default:
      storeKey = "contractorPerson";
      storeType = USER_DATA_CONSTANT.CONTRACTOR_PERSON;
      break;
  }

  const contractorPersonData = Store.getState()?.userManagement?.[storeKey];
  if (
    Array.isArray(contractorPersonData?.data?.data) &&
    contractorPersonData?.data?.data?.length
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from Store",
          data: contractorPersonData.data.data,
          other: { employee_form_a: contractorPersonData.data.employee_form_a },
        });
      }, 0);
    });
  } else {
    let result = {};
    const currentDate = new Date();
    const currentTime = moment(currentDate, "HH:mm").format("HH:mm");
    const saveData = localStorageService.getItem("contractorPersonListData");
    const addTime = saveData?.time ? addMinutes(saveData?.time, 5) : "";
    let url =
      "/user-management/contractor-person" +
      ((filterType && `?type=${filterType}`) || "");

    const siteList = await getAllSites();
    const siteListData = await getAllSitesData();
    // const contractorList = await getContractor();
    const contractorList = await getContractorForOtherModuel();
    // console.log("contractorList++++", contractorList);
    // if (saveData?.data && addTime >= currentTime && !data?.apiFlag) {
    //   return (result = saveData?.data);
    // } else {
    result = await CallApi(url, "GET", data);
    const finalData = (result?.data || [])?.map((d) => {
      const siteObj =
        (siteList?.data || [])?.find((obj) => obj?.id === d?.currentWorkLocation) ||
        (siteListData?.data || [])?.find((obj) => obj?.id === d?.currentWorkLocation);
      const contractorObj = (contractorList?.data || [])?.find(
        (obj) => obj?.id === +d?.contractorId
      );
      const formAObj =
        (result?.other?.employee_form_a || [])?.find(
          (obj) => obj?.contractorId === d?.id
        ) || "";
      return {
        ...d,
        ehsSite: siteObj || {},
        contractorFormA: formAObj,
        contractors: contractorObj,
      };
    });
    let finalResult = { ...result, data: finalData };
    let storeData = {
      data: finalResult?.data,
      employee_form_a: finalResult?.other?.employee_form_a,
    };
    Store.dispatch({
      type: storeType,
      data: storeData,
    });
    return finalResult;
  }
};

export const getContractorPersonById = async (id) => {
  let url = "/user-management/contractor-person/" + id;
  return await CallApi(url, "GET");
};

export async function getContractorPersonFormAHistoryByID(id) {
  const url = "/user-management/contractor-person/form-a/history/" + id;

  const response = await CallApi(url, "GET");

  return response;
}

export async function getAllContractorPersonFormAHistoryByID(id) {
  const url = "/user-management/contractor-person/form-a/history-all/" + id;

  const response = await CallApi(url, "GET");

  return response;
}

export async function updateContractorFormA(id, data) {
  try {
    const response = await CallApi(
      "/user-management/contractor-person/form-a/" + id,
      "PUT",
      data
    );
    return response;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export const createContractorPerson = async (data) => {
  let url = "/user-management/contractor-person";
  return await CallApi(url, "POST", data);
};

export async function uploadContractorPersonByExcel(data) {
  let url = "/user-management/contractor-person/upload-excel";
  return await CallApi(url, "POST", data);
}

export async function downloadContractorExcel() {
  let url = "/user-management/contractor-person/download-excel";
  return await CallApi(url, "GET");
}
export const addContractorPersonsExcel = async (data) => {
  let url = "/user-management/contractor-person/save-excel-data";
  return await CallApi(url, "POST", data);
};

export const updateContractorPerson = async (id, data) => {
  let url = "/user-management/contractor-person/" + id;
  return await CallApi(url, "PUT", data);
};

export const deleteContractorPerson = async (id) => {
  let url = "/user-management/contractor-person/" + id;
  return await CallApi(url, "DELETE");
};

export async function updateContractorPersonEmploymentStatus(id, data, query) {
  let url = "/user-management/update-contractor-person-employment-status/" + id;
  if (query) url = url + "?" + query;
  const response = await CallApi(url, "PUT", data);
  if (response?.status) {
    clearContractorPersonStore();
  }
  return response;
}

export async function updateMultiContractorPersonEmploymentStatus(data) {
  let url = "/user-management/update-multi-contractor-person-employment-status";
  const response = await CallApi(url, "POST", data);
  if (response?.status) {
    clearContractorPersonStore();
  }
  return response;
}

export async function updateContractorPersonCurrentLocation(id, data, query) {
  let url = "/user-management/update-contractor-person-current-location/" + id;
  if (query) url = url + "?" + query;
  return await CallApi(url, "PUT", data);
}

export async function updateContractorPersonDesignation(id, data) {
  let url = "/user-management/update-contractor-person-designation/" + id;
  return await CallApi(url, "PUT", data);
}

export async function updateContractorPersonMedical(id, data) {
  let url = "/user-management/update-contractor-person-medical-exam/" + id;
  return await CallApi(url, "PUT", data);
}

export async function updateContractorPersonBasicDetails(id, data) {
  let url = "/user-management/update-contractor-person-basic-data/" + id;
  return await CallApi(url, "PUT", data);
}

export async function getContPersonForOtherModuel() {
  const resultData = Store.getState()?.userManagement?.contPersonForOthrModuel;
  if (Array.isArray(resultData) && resultData?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from Store",
          data: resultData,
        });
      }, 0);
    });
  } else {
    let url = "/user-management/contractor-person-for-other-moduel";
    let response = await CallApi(url, "GET");
    Store.dispatch({
      type: USER_DATA_CONSTANT.CONTRACTOR_PERSON_FOR_OTHER_MODUEL,
      data: response?.data,
    });
    return response;
  }
}

export async function getAllOldContPerson() {
  const resultData = Store.getState()?.userManagement?.oldContractorPerson;
  if (Array.isArray(resultData) && resultData?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from Store",
          data: resultData,
        });
      }, 0);
    });
  } else {
    let url = "/user-management/all-old-contractor-person";
    let response = await CallApi(url, "GET");
    Store.dispatch({
      type: USER_DATA_CONSTANT.OLD_CONTRACTOR_PERSON,
      data: response?.data,
    });
    return response;
  }
}
